import React from 'react';
import { Button, Form, FormGroup, Input, Label, Row, Col } from 'reactstrap';

class CompensationForm extends React.Component {
  constructor(props) {
    super(props);
  }

  handleSubmit = event => {
    event.preventDefault();
    this.props.history.push('/');
  };

  render() {
    return <Form onSubmit={this.handleSubmit} className="AuthForm"></Form>;
  }
}

export default CompensationForm;
